import { Component, type ErrorInfo, type PropsWithChildren, type ReactNode } from "react";

interface State {
  error?: Error;
}

export class ErrorBoundary extends Component<PropsWithChildren, State> {
  public state: State = {};

  public static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  public componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("Application error", error, info);
  }

  public render(): ReactNode {
    if (this.state.error) {
      return (
        <main className="centered-state">
          <div className="state-panel">
            <h1>Something went wrong</h1>
            <p>{this.state.error.message}</p>
          </div>
        </main>
      );
    }

    return this.props.children;
  }
}
